import { atom } from "recoil";

/**
 * A clock the time-based filters read, ticking once a minute: "Moving", "Working now", a phone gone
 * quiet and a missed time window change with time even when nothing about the person or job does.
 */
export const filterClockState = atom<number>({
    key: "filters.clock",
    default: Date.now(),
});
